import StoreService from './store/StoreService';
import { STORE_SERVICE_ID } from '../interface/services';
import { globalAddinContainer } from '../extensibility/AddinContainer';

export default function initialize() {
    globalAddinContainer.addService(STORE_SERVICE_ID, new StoreService());
}
